import React from 'react';
import Icon from '../../../components/AppIcon';

const UpcomingEvents = () => {
  const events = [
    {
      id: 1,
      title: 'Team Standup',
      time: '09:00 - 09:15',
      date: '22/11/2025',
      type: 'meeting',
      attendees: 8,
      location: 'Zoom',
      color: 'primary'
    },
    {
      id: 2,
      title: 'Onboarding Session with HR',
      time: '14:00 - 15:00',
      date: '22/11/2025',
      type: 'training',
      attendees: 3,
      location: 'Conference Room A',
      color: 'success'
    },
    {
      id: 3,
      title: 'Welcome Lunch with Team',
      time: '12:30 - 13:30',
      date: '23/11/2025',
      type: 'social',
      attendees: 12,
      location: 'Office Cafeteria',
      color: 'warning'
    }
  ];

  const getIconForType = (type) => {
    const icons = {
      meeting: 'Video',
      training: 'GraduationCap',
      social: 'Coffee'
    };
    return icons?.[type] || 'Calendar';
  };

  const getColorClasses = (color) => {
    const colors = {
      primary: 'bg-primary/10 text-primary border-primary/20',
      success: 'bg-success/10 text-success border-success/20',
      warning: 'bg-warning/10 text-warning border-warning/20'
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-bold text-foreground">Upcoming Events</h2>
          <p className="text-sm text-muted-foreground mt-1">Your schedule for the next 2 days</p>
        </div>
        <Icon name="Calendar" size={24} color="var(--color-primary)" strokeWidth={2} />
      </div>
      <div className="space-y-4">
        {events?.map((event) => (
          <div
            key={event?.id}
            className="p-4 rounded-lg border border-border bg-muted/20 hover:bg-muted/30 transition-all duration-200 hover:shadow-elevation-1"
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center shrink-0 ${getColorClasses(event?.color)}`}>
                <Icon name={getIconForType(event?.type)} size={20} color="currentColor" strokeWidth={2} />
              </div>
              
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-foreground mb-1">{event?.title}</h3>
                <div className="space-y-1">
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <Icon name="Clock" size={14} color="currentColor" />
                    <span>{event?.time}</span>
                    <span className="text-xs">•</span>
                    <span>{event?.date}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <Icon name="MapPin" size={14} color="currentColor" />
                    <span>{event?.location}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-muted-foreground">
                    <Icon name="Users" size={14} color="currentColor" />
                    <span>{event?.attendees} attendees</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <button className="w-full py-2 text-sm font-medium text-primary hover:text-primary/80 transition-colors duration-150 flex items-center justify-center gap-2">
          <Icon name="Plus" size={16} color="currentColor" />
          View Full Calendar
        </button>
      </div>
    </div>
  );
};

export default UpcomingEvents;